export default __webpack_public_path__ + "imgs/a9b3adca.png";